import { useReducer } from 'react';
import { calculatorReducer, initialFormState } from '../calculatorReducer';

export const useCalculatorForm = () => {
  const [formData, dispatch] = useReducer(calculatorReducer, initialFormState);

  return {
    formData,
    selectChallenge: (challenge: string) =>
      dispatch({ type: 'SELECT_CHALLENGE', payload: challenge }),
    toggleService: (service: string) => dispatch({ type: 'TOGGLE_SERVICE', payload: service }),
    setWorkshopType: (type: string) => dispatch({ type: 'SET_WORKSHOP_TYPE', payload: type }),
    setTechnologiesText: (text: string) =>
      dispatch({ type: 'SET_TECHNOLOGIES_TEXT', payload: text }),
    setEmail: (email: string) => dispatch({ type: 'SET_EMAIL', payload: email }),
    toggleTerms: () => dispatch({ type: 'TOGGLE_TERMS' }),
  };
};
